import { PayloadAction } from '@reduxjs/toolkit'
import Creation from 'Entity/Creation'
import {
    initialLayoutState,
    StudioState,
    createNewPageData,
    PageData,
    generateTempUUID,
} from '../initialState'

export const canvasReducer = {
    setCreationData: (state: StudioState, action: PayloadAction<Creation>) => {
        const creation = action.payload
        state.creationId = creation.id

        if (creation.data && creation.data.pages) {
            const restoredPages: Record<string, PageData> = {}
            const restoredPageIds: string[] = creation.data.pageIds || []

            restoredPageIds.forEach((pageId) => {
                const pageData = creation.data.pages[pageId]
                if (pageData) {
                    restoredPages[pageId] = {
                        ...createNewPageData(
                            pageId,
                            pageData.name || 'Untitled',
                        ),
                        ...pageData,
                        id: pageId,
                        assets: pageData.assets || {},
                        layouts: pageData.layouts || {
                            desktop: {
                                ...initialLayoutState,
                                items: {},
                                itemIds: [],
                            },
                            mobile: {
                                ...initialLayoutState,
                                items: {},
                                itemIds: [],
                            },
                        },
                        selectedItemIds: pageData.selectedItemIds || [],
                    }
                }
            })

            state.pages = restoredPages
            state.pageIds = restoredPageIds
            state.activePageId =
            creation.data.activePageId || restoredPageIds[0] || null
        } else {
            const pageId = generateTempUUID()
            const newPage = createNewPageData(pageId, 'Page 1')
            state.pages = { [newPage.id]: newPage }
            state.pageIds = [newPage.id]
            state.activePageId = newPage.id
        }
    },
}
